const ENDPOINTS: any = {
    //start of updated api endpoints
    v1: {
        taxonomy: '/api/v1/taxonomies',
        // hierarchies:''
    },
    versions: {
        versionList: 'api/v1/taxonomies/versions',
    },
    hierarchies: {
        hierarchyList: 'api/v1/taxonomies/hierarchies',
    },
    homePage: {
        CategoryListRoots: 'api/v1/hierarchies/categories/roots',
        CategoryIdChildren: 'api/v1/hierarchies/categories/children',
        CategoryDetails: '/api/v1/hierarchies/categories',
        CategoryAttributes: 'api/v1/categories/attributes',
        attributes: 'api/v1/taxonomies/attributes',
        attributeDetails: 'api/v1/attributes/categories',
        searchAttributes: 'api/v1/search/attributes',
        searchCategories: 'api/v1/search/categories/tree',
        CategoryAttributesList: 'api/v1/taxonomies/attributes/attached',
        GlobalAttributesList: 'api/v1/taxonomies/attributes',

        // attributDetails:'api/v1/attributes/bdeb6585-7ac2-402f-b197-1d02ed8f6bb1/categories'
    },
    codeset: {
        uomcodesets: 'api/v1/taxonomies/uomcodesets',
        uomcodesetUnits: 'api/v1/uomcodesets/units',
        valuecodesets: 'api/v1/taxonomies/valuecodesets',
        valuecodesetValues: 'api/v1/valuecodesets/values',
        attributeconflicts: 'api/v1/taxonomies/attributes/conflicts',
        uomConflicts: 'api/v1/taxonomies/attributes/conflicts',
        searchCodesetUnits: 'api/v1/search/codes/units',
        searchCodesetValues: 'api/v1/search/codes/values',
        searchMutipleValues: 'api/v1/search/multi-search',
        searchCodesetUnitsWithin: 'api/v1/search/units',
        searchCodesetValuesWithin: 'api/v1/search/values',
    },
    info: {
        emptyCategories: 'api/v1/taxonomies/categories/empty',
        freeCategories: 'api/v1/taxonomies/categories/free',
        connectedCategories: 'api/v1/taxonomies/categories/connected',
        connectedHierarchies: 'api/v1/categories/ancestors',
        categoryDetails: 'api/v1/categories',
        attributeDetails: 'api/v1/attributes',
        freeAttributes: 'api/v1/taxonomies/attributes/free',
    },
    addCategory: {
        leafNode: 'api/v1/taxonomies/categories',
    },
    addAttribute: {
        attribute: 'api/v1/taxonomies/attributes',
    },
    tickets: {
        ticketsList: 'api/v1/taxonomies/:taxonomy_id/tickets',
        ticketDetail: 'api/v1/tickets/:ticket_id',
        ticketCreation: 'api/v1/:taxonomy_id/tickets',
        ticketCreationBatch: 'api/v1/:taxonomy_id/tickets/batch',
    },
    editRelations: {
        relations: 'api/v1/hierarchies/categories/lineage',
    },
    search: {
        codesetUnits: 'search/codes/units?q=<string>&taxonomy_id=<uuid>',
        codesetValues: 'search/codes/values?q=<string>&taxonomy_id=<uuid>',
    },
    //end of updated api endpoints

    users: {
        login: 'api/v1/users/login',
        logout: 'api/v1/users/logout',
        me: 'api/v1/users/me',
    },
    client: {
        list: '/api/clients/',
        settings: '/api/clients/setting/',
    },

    version: {
        versionList: '/api/versions/',
        history: '/api/versions/edit_logs/',
    },

    hierarchy: {
        hierarchyList: '/api/hierarchies/',
        categories: '/api/taxonomies/categories/',
        categoryDetailsAll: '/api/versions/hierarchies/categories/',
        categoryDetailsDialog: '/api/',
        categoryDetails: '/api/taxonomies/categories/',
        attributes: '/api/taxonomies/attributes/',
        valid_values: '/api/taxonomies/attributes/',
        uom_values: '/api/taxonomies/attributes/',
        free_nodes: '/api/taxonomies/hierarchies/',
        add_relation: '/api/drafts/',
        get_attributes_data: '/api/taxonomies/attributes/list/',
        get_node_data: '/api/taxonomies/categories/list/',
        check_copy_option: '/api/drafts/copy/options/',
        validate_option: '/api/drafts/validate/',
        freeNodeList: 'api/v1/hierarchies/categories/free',
    },

    home: {
        tree_data: '/api/categories/',
        node_details: '/api/categories/',
        search: '/api/categories/search/',
        empty_nodes: '/api/taxonomies/hierarchies/empty_nodes/',
        uom_conflict: '/api/taxonomies/uom_codesets/conflicts/',
    },

    node_info: {
        all_info: '/api/tree/view/node/properties/',
    },

    taxonomy: {
        export: '/api/export/',
    },

    attribute: {
        valueCodeset: '/api/taxonomies/value_codesets/',
        valueCodesetDetails: '/api/taxonomies/value_codesets/',
        uom: '/api/taxonomies/uom_codesets/',
        list: '/api/attributes/',
        selectiveList: '/api/categories/',
        validValue: '/api/value_codesets/search/',
        details: '/api/categories/',
        uomDetails: '/api/taxonomies/uom_codesets/',
        search: '/api/attributes/search/',
        datas: '/api/attributes/list/',
        scoreEdit: '/api/versions/edit_field/',
    },

    data: {
        attributes: '/api/attributes/list/',
        categories: '/api/categories/list/',
        datas: '/api/categories/list/',
    },

    validate: {
        category_name: '/api/taxonomies/categories/validate_name/',
        category_code: '/api/taxonomies/categories/validate_name/',
    },

    node: {
        edit: '/api/drafts/',
        add: '/api/drafts/',
        hierarchy: '/api/taxonomies/categories/',
    },
    draft: {
        list: '/api/drafts/',
        submit: '/api/drafts/',
        publish: '/api/drafts/publish/',
        comment: '/api/tickets/',
        freeze: '/api/drafts/freeze/',
        unfreeze: '/api/drafts/unfreeze/',
        status: '/api/drafts/publish/status/',
        clear: '/api/drafts/clear/',
        history: '/api/drafts/',
    },

    file: {
        uomUpload: '/api/codesets/upload/',
        exportUoM: '/api/uom_codesets/export/',
        exportValidValues: '/api/value_codesets/export/',
        codesetUpload: '/api/codesets/upload/',
    },

    node_properties: {
        properties: 'api/tree/view/node/edit/',
        attachment_upload: 'api/tree/view/node/edit/upload/',
        draft: '/api/tree/view/node/edit/draft/',
        review: '/api/tree/view/node/edit/review/',
        reject: '/api/tree/view/node/edit/review/reject/',
        accept: '/api/tree/view/node/edit/review/accept/',
        submitStatus: '/api/tree/view/node/edit/review/status/',
    },
};

export { ENDPOINTS };
